import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DefaultComponent } from "../default.component";

@Component({
  standalone: true,
  selector: "app-splash",
  imports: [TranslateModule],
  templateUrl: "./splash.component.html",
  styleUrl: "./splash.component.less",
})
export class SplashScreenComponent extends DefaultComponent {
  public constructor() {
    super();
  }
}
